import { Matrix3, Matrix4, Vector3 } from "three";
import GeometryCommand from "./GeometryCommand";
import CommandIdEnum from "../enums/CommandIdEnums";
import ICanvasInputListener from "../logic/ICanvasInputListener";
import Document from "../model/document/Document";
import CommandStack from "../logic/CommandStack";
import EditHandleData from "../model/sceneObjectData/EditHandleData";
import ISceneObject from "../model/sceneObject/ISceneObject";
import IParameterizable from "../interfaces/IParameterizable";

export default abstract class GeometryEditCmd extends GeometryCommand implements IParameterizable<EditHandleData> {
    protected editHandleData!: EditHandleData;
    protected ownerSceneObject!: ISceneObject;
    protected parentWorldMatrix!: Matrix4;

    constructor(
        id: CommandIdEnum,
        commandStack: CommandStack,
        canvasInputListener: ICanvasInputListener,
        document: Document,
    ) {
        super(id, commandStack, canvasInputListener, document);
    }

    setParameters(editHandleData: EditHandleData): void {
        this.editHandleData = editHandleData;
        const owner = this.getDocument().getSceneObject(editHandleData.ownerUuid);
        if (!owner) throw new Error(`GeometryEditCmd: owner ${editHandleData.ownerUuid} not found`);
        this.ownerSceneObject = owner;
        this.parentWorldMatrix = owner.getWorldMatrix().clone();
    }

    /**
     * Computes the local-space delta between the handle's world-space origin
     * and the given world-space target point.
     */
    protected computeLocalDelta(worldPoint: Vector3): Vector3 {
        // editHandleData.position is already in world space (transformed by SelectCmd.showHandles)
        const worldDelta = worldPoint.clone().sub(this.editHandleData.position);
        const parentInverseRotScale = new Matrix3().setFromMatrix4(this.parentWorldMatrix.clone().invert());
        return worldDelta.clone().applyMatrix3(parentInverseRotScale);
    }
}
